import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import {
  MagicMomentDayOverride,
  useDevOverridesStore,
} from "@/lib/hooks/admin/use-dev-overrides";

const OPTIONS: { value: "off" | "day1" | "day2"; label: string }[] = [
  { value: "off", label: "Off" },
  { value: "day1", label: "Force Day 1 banner" },
  { value: "day2", label: "Force Day 2 banner" },
];

export function DevSettings() {
  const magicMomentDay = useDevOverridesStore((s) => s.magicMomentDay);
  const forceDay2Modal = useDevOverridesStore((s) => s.forceDay2Modal);
  const setMagicMomentDay = useDevOverridesStore((s) => s.setMagicMomentDay);
  const setForceDay2Modal = useDevOverridesStore((s) => s.setForceDay2Modal);
  const reset = useDevOverridesStore((s) => s.reset);

  const radioValue = magicMomentDay ?? "off";

  const handleRadioChange = (value: string) => {
    const next: MagicMomentDayOverride =
      value === "day1" || value === "day2" ? value : null;
    setMagicMomentDay(next);
  };

  return (
    <div className="space-y-8 py-6">
      <section className="space-y-4">
        <div>
          <h2 className="text-lg font-semibold text-black">Magic moment</h2>
          <p className="text-sm text-stone-600">
            Override the Day 1 / Day 2 magic-moment gating for any conversation
            you open. Persists in localStorage. Only visible to superadmins.
          </p>
        </div>

        <RadioGroup
          value={radioValue}
          onValueChange={handleRadioChange}
          className="gap-3"
        >
          {OPTIONS.map((opt) => (
            <div key={opt.value} className="flex items-center gap-2">
              <RadioGroupItem
                value={opt.value}
                id={`magic-moment-${opt.value}`}
              />
              <Label
                htmlFor={`magic-moment-${opt.value}`}
                className="cursor-pointer text-sm font-normal"
              >
                {opt.label}
              </Label>
            </div>
          ))}
        </RadioGroup>

        {magicMomentDay === "day2" && (
          <div className="flex items-center gap-2 pl-6">
            <Checkbox
              id="force-day2-modal"
              checked={forceDay2Modal}
              onCheckedChange={(value) => setForceDay2Modal(value === true)}
            />
            <Label
              htmlFor="force-day2-modal"
              className="cursor-pointer text-sm font-normal"
            >
              Also show the Day 2 modal
            </Label>
          </div>
        )}

        <p className="text-xs text-stone-500">
          Open any active conversation to see the banner.
        </p>
      </section>

      <div>
        <Button variant="outline" size="sm" onClick={reset}>
          Reset overrides
        </Button>
      </div>
    </div>
  );
}
